module.exports = __webpack_public_path__ + "img/xp3_shield.fbbb38fe.jpg";